"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spa = void 0;
var _Root = require("./Root");
var _Script = require("./Script");
var _hooks = require("./hooks");
var _jsxRuntime = require("react/jsx-runtime");
const Spa = props => {
  const {
    id,
    appUrl,
    config,
    scriptOnly,
    src
  } = (0, _hooks.useSpa)(props);
  const {
    rootAttributes = {}
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [scriptOnly ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Root.Root, {
      id: id.root,
      appUrl: appUrl,
      attributes: rootAttributes,
      config: config
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Script.Script, {
      id: id.script,
      src: src
    })]
  });
};
exports.Spa = Spa;
